import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-md-3 col-sm-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "title ms-15" }
const _hoisted_7 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_8 = { class: "fw-black mb-8 lh-1" }
const _hoisted_9 = { class: "col-md-3 col-sm-6" }
const _hoisted_10 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_11 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "title ms-15" }
const _hoisted_14 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_15 = { class: "fw-black mb-8 lh-1" }
const _hoisted_16 = { class: "col-md-3 col-sm-6" }
const _hoisted_17 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_18 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "title ms-15" }
const _hoisted_21 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_22 = { class: "fw-black mb-8 lh-1" }
const _hoisted_23 = { class: "col-md-3 col-sm-6" }
const _hoisted_24 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_25 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "title ms-15" }
const _hoisted_28 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_29 = { class: "fw-black mb-8 lh-1" }
const _hoisted_30 = { class: "col-md-3 col-sm-6" }
const _hoisted_31 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_32 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "title ms-15" }
const _hoisted_35 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_36 = { class: "fw-black mb-8 lh-1" }
const _hoisted_37 = { class: "col-md-3 col-sm-6" }
const _hoisted_38 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_39 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = { class: "title ms-15" }
const _hoisted_42 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_43 = { class: "fw-black mb-8 lh-1" }
const _hoisted_44 = { class: "col-md-3 col-sm-6" }
const _hoisted_45 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_46 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = { class: "title ms-15" }
const _hoisted_49 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_50 = { class: "fw-black mb-8 lh-1" }
const _hoisted_51 = { class: "col-md-3 col-sm-6" }
const _hoisted_52 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_53 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "title ms-15" }
const _hoisted_56 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_57 = { class: "fw-black mb-8 lh-1" }
const _hoisted_58 = { class: "col-md-12" }
const _hoisted_59 = { class: "card mb-25 border-0 rounded-0 mb-20" }
const _hoisted_60 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_61 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_62 = { class: "title" }
const _hoisted_63 = { class: "card-title fw-black mb-0" }
const _hoisted_64 = { class: "col-md-8" }
const _hoisted_65 = { class: "chart" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_69 = { class: "card-header" }
const _hoisted_70 = { class: "mb-25 fw-black" }
const _hoisted_71 = { class: "card-body" }
const _hoisted_72 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_73 = { class: "fw-black" }
const _hoisted_74 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_75 = { class: "fw-black" }
const _hoisted_76 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_77 = { class: "fw-black" }
const _hoisted_78 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_79 = { class: "fw-black text-danger" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_82 = { class: "card-header" }
const _hoisted_83 = { class: "mb-25 fw-black" }
const _hoisted_84 = { class: "card-body" }
const _hoisted_85 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_86 = { class: "fw-black" }
const _hoisted_87 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_88 = { class: "fw-black" }
const _hoisted_89 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_90 = { class: "fw-black" }
const _hoisted_91 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_92 = { class: "fw-black text-danger" }
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_95 = { class: "card-header" }
const _hoisted_96 = { class: "mb-25 fw-black" }
const _hoisted_97 = { class: "card-body" }
const _hoisted_98 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_99 = { class: "fw-black" }
const _hoisted_100 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_101 = { class: "fw-black" }
const _hoisted_102 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_103 = { class: "fw-black text-danger" }
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_106 = { class: "card-header" }
const _hoisted_107 = { class: "mb-25 fw-black" }
const _hoisted_108 = { class: "card-body" }
const _hoisted_109 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_110 = { class: "fw-black" }
const _hoisted_111 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_112 = { class: "fw-black" }
const _hoisted_113 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_114 = { class: "fw-black text-danger" }
const _hoisted_115 = { class: "col-12" }
const _hoisted_116 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white"
}
const _hoisted_117 = { class: "card-header" }
const _hoisted_118 = { class: "mb-25 fw-black" }
const _hoisted_119 = { class: "card-body" }
const _hoisted_120 = { class: "row" }
const _hoisted_121 = { class: "col-md-3 col-sm-6 mb-2" }
const _hoisted_122 = { class: "d-flex align-items-center" }
const _hoisted_123 = { class: "text-muted" }
const _hoisted_124 = { class: "col-md-3 col-sm-6 mb-2" }
const _hoisted_125 = { class: "d-flex align-items-center" }
const _hoisted_126 = { class: "text-muted" }
const _hoisted_127 = { class: "col-md-3 col-sm-6 mb-2" }
const _hoisted_128 = { class: "d-flex align-items-center" }
const _hoisted_129 = { class: "text-muted" }
const _hoisted_130 = { class: "col-md-3 col-sm-6 mb-2" }
const _hoisted_131 = { class: "d-flex align-items-center" }
const _hoisted_132 = { class: "text-muted" }
const _hoisted_133 = { class: "col-12" }
const _hoisted_134 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white"
}
const _hoisted_135 = { class: "card-header" }
const _hoisted_136 = { class: "mb-25 fw-black" }
const _hoisted_137 = { class: "card-body" }
const _hoisted_138 = { class: "row" }
const _hoisted_139 = { class: "col-md-4 col-sm-6 mb-2" }
const _hoisted_140 = { class: "d-flex align-items-center" }
const _hoisted_141 = { class: "text-muted" }
const _hoisted_142 = { class: "col-md-4 col-sm-6 mb-2" }
const _hoisted_143 = { class: "d-flex align-items-center" }
const _hoisted_144 = { class: "text-muted" }
const _hoisted_145 = { class: "col-md-4 col-sm-6 mb-2" }
const _hoisted_146 = { class: "d-flex align-items-center" }
const _hoisted_147 = { class: "text-muted" }
const _hoisted_148 = {
  key: 1,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_ctx.dashData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "mb-20" }, "Statistiques Générals", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.NEW_PARCEL?.color + ' !important',
              })
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.dashData?.ParcelsStatus?.NEW_PARCEL?.name ?? "Nouveaux Colis"), 1),
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.dashData?.ParcelsStatus?.NEW_PARCEL?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.WAITING_PICKUP?.color +
                  ' !important',
              })
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.dashData?.ParcelsStatus?.WAITING_PICKUP?.name ??
                  "En Attente de Ramassage"), 1),
                  _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.dashData?.ParcelsStatus?.WAITING_PICKUP?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.PICKED_UP?.color + ' !important',
              })
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.dashData?.ParcelsStatus?.PICKED_UP?.name ?? "Colis Ramassés"), 1),
                  _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.dashData?.ParcelsStatus?.PICKED_UP?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.DISTRIBUTION?.color + ' !important',
              })
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DISTRIBUTION?.name ??
                  "En Distribution"), 1),
                  _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DISTRIBUTION?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.IN_PROGRESS?.color + ' !important',
              })
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.dashData?.ParcelsStatus?.IN_PROGRESS?.name ?? "En Cours"), 1),
                  _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.dashData?.ParcelsStatus?.IN_PROGRESS?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.DELIVERED?.color + ' !important',
              })
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DELIVERED?.name ?? "Livrés"), 1),
                  _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DELIVERED?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color: _ctx.dashData?.ParcelsStatus?.REFUSE?.color + ' !important',
              })
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.dashData?.ParcelsStatus?.REFUSE?.name ?? "Refusés"), 1),
                  _createElementVNode("h4", _hoisted_50, _toDisplayString(_ctx.dashData?.ParcelsStatus?.REFUSE?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", {
                  class: "icon position-relative rounded-circle text-center",
                  style: _normalizeStyle({
                color: _ctx.dashData?.ParcelsStatus?.RETURNED?.color + ' !important',
              })
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
                ]), 4),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.dashData?.ParcelsStatus?.RETURNED?.name ?? "Retournés"), 1),
                  _createElementVNode("h4", _hoisted_57, _toDisplayString(_ctx.dashData?.ParcelsStatus?.RETURNED?.num ?? 0), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("h5", _hoisted_63, _toDisplayString(_ctx.dashData?.totalParcels) + " Colis ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_apexchart, {
                      type: "line",
                      height: "325",
                      options: _ctx.statisticsProfit.chartOptions,
                      series: _ctx.chartData
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "card-title" }, "Total Bons Paiment Payé (Livreur)", -1)),
                _createElementVNode("h6", _hoisted_70, _toDisplayString(_ctx.dashData?.totalNotePaid ?? 0) + " Bons ", 1)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-success text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-sterile-box\"></i></div><div><h6 class=\"mb-0 fw-medium\">Colis</h6><small class=\"text-muted\">Total Colis</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.dashData?.payn_l_parcels ?? 0) + " Colis ", 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-danger text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Crbt</h6><small class=\"text-muted\">Total Crbt</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.dashData?.payn_l_crbt ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-primary text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-express-delivery\"></i></div><div><h6 class=\"mb-0 fw-medium\">Frais</h6><small class=\"text-muted\">Total Frais</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.dashData?.payn_l_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-info text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Total</h6><small class=\"text-muted\">Total</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.dashData?.payn_l_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "card-title" }, "Total Bons Paiment Non Payé (Livreur)", -1)),
                _createElementVNode("h6", _hoisted_83, _toDisplayString(_ctx.dashData?.totalNoteNotPaid ?? 0) + " Bons ", 1)
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-success text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-sterile-box\"></i></div><div><h6 class=\"mb-0 fw-medium\">Colis</h6><small class=\"text-muted\">Total Colis</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.dashData?.payn_l_not_parcels ?? 0) + " Colis ", 1)
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-danger text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Crbt</h6><small class=\"text-muted\">Total Crbt</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.dashData?.payn_l_not_crbt ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-primary text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-express-delivery\"></i></div><div><h6 class=\"mb-0 fw-medium\">Frais</h6><small class=\"text-muted\">Total Frais</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.dashData?.payn_l_not_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-info text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Total</h6><small class=\"text-muted\">Total</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.dashData?.payn_l_not_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "card-title" }, "Total Bons Paiment Payé (Zone)", -1)),
                _createElementVNode("h6", _hoisted_96, _toDisplayString(_ctx.dashData?.totalZNotePaid ?? 0) + " Bons ", 1)
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-success text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-sterile-box\"></i></div><div><h6 class=\"mb-0 fw-medium\">Colis</h6><small class=\"text-muted\">Total Colis</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.dashData?.payn_z_parcels ?? 0) + " Colis ", 1)
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-primary text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-express-delivery\"></i></div><div><h6 class=\"mb-0 fw-medium\">Frais</h6><small class=\"text-muted\">Total Frais</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.dashData?.payn_z_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-info text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Total</h6><small class=\"text-muted\">Total</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.dashData?.payn_z_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "card-title" }, "Total Bons Paiment Non Payé (Zone)", -1)),
                _createElementVNode("h6", _hoisted_107, _toDisplayString(_ctx.dashData?.totalZNoteNotPaid ?? 0) + " Bons ", 1)
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("div", _hoisted_109, [
                  _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-success text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-sterile-box\"></i></div><div><h6 class=\"mb-0 fw-medium\">Colis</h6><small class=\"text-muted\">Total Colis</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.dashData?.payn_z_not_parcels ?? 0) + " Colis ", 1)
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-primary text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-express-delivery\"></i></div><div><h6 class=\"mb-0 fw-medium\">Frais</h6><small class=\"text-muted\">Total Frais</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.dashData?.payn_z_not_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-info text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Total</h6><small class=\"text-muted\">Total</small></div></div>", 1)),
                  _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.dashData?.payn_z_not_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_115, [
            (_ctx.dashData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                  _createElementVNode("div", _hoisted_117, [
                    _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "card-title" }, "Total Bons (Livreur)", -1)),
                    _createElementVNode("h6", _hoisted_118, _toDisplayString(_ctx.dashData?.total_l_payn ?? 0) + " Bons ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("div", _hoisted_122, [
                          _cache[28] || (_cache[28] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-primary text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-sterile-box" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[27] || (_cache[27] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total Colis", -1)),
                            _createElementVNode("small", _hoisted_123, _toDisplayString(_ctx.dashData?.total_l_parcels ?? 0) + " Colis", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-danger text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-money" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total Crbt", -1)),
                            _createElementVNode("small", _hoisted_126, _toDisplayString(_ctx.dashData?.total_l_crbt ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("div", _hoisted_128, [
                          _cache[32] || (_cache[32] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-secondary text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-express-delivery" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total Frais", -1)),
                            _createElementVNode("small", _hoisted_129, _toDisplayString(_ctx.dashData?.total_l_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _cache[34] || (_cache[34] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-info text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-money" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[33] || (_cache[33] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total", -1)),
                            _createElementVNode("small", _hoisted_132, _toDisplayString(_ctx.dashData?.total_l_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_133, [
            (_ctx.dashData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "card-title" }, "Total Bons (Zone)", -1)),
                    _createElementVNode("h6", _hoisted_136, _toDisplayString(_ctx.dashData?.total_z_payn ?? 0) + " Bons ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                          _cache[37] || (_cache[37] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-primary text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-sterile-box" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[36] || (_cache[36] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total Colis", -1)),
                            _createElementVNode("small", _hoisted_141, _toDisplayString(_ctx.dashData?.total_z_parcels ?? 0) + " Colis ", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _cache[39] || (_cache[39] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-secondary text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-express-delivery" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[38] || (_cache[38] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total Frais", -1)),
                            _createElementVNode("small", _hoisted_144, _toDisplayString(_ctx.dashData?.total_z_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_145, [
                        _createElementVNode("div", _hoisted_146, [
                          _cache[41] || (_cache[41] = _createElementVNode("div", {
                            class: "icon position-relative rounded-circle text-center bg-info text-white me-15",
                            style: {"width":"42px","height":"42px","display":"flex","align-items":"center","justify-content":"center"}
                          }, [
                            _createElementVNode("i", { class: "flaticon-money" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[40] || (_cache[40] = _createElementVNode("h6", { class: "mb-0 fw-medium" }, "Total", -1)),
                            _createElementVNode("small", _hoisted_147, _toDisplayString(_ctx.dashData?.total_z_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_148, _cache[43] || (_cache[43] = [
        _createElementVNode("h3", { class: "mb-20" }, "Statistiques Générals", -1),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("div", { class: "alert alert-info" }, "Aucune donnée disponible.")
        ], -1)
      ])))
}